export default __webpack_public_path__ + "static/banner-baby-first-drive-home-37d8f561c32e6787d13f5bf9fa1e6ba0.jpg";